import * as React from 'react';
import { DataGroup } from '../../../components/data-group/DataGroup';
import { DataGroupPoint } from '../../../components/data-group/DataGroupPoint';
import { TimeZoneAbbreviations } from '../../../components/utility/timezones';
import { formatCurrency } from '../../../utils/currency-formatter';
import { toLongDateTimeNoSeconds } from '../../../utils/date-utils';
import { DeliveryStatusMetadata } from '../../models/enums/delivery-status';
import { ShipmentType } from '../../models/enums/shipment-type';
import { DeliveryShipmentAction } from '../../models/shipments/shipment-action';

interface IProps {
    stop : DeliveryShipmentAction;
    includeFreight: boolean;
    changeAddress: any|undefined;
    entityType: ShipmentType;
}

export const ShipmentActionCustomerDeliveryInfo = (props : IProps) => {
    return <React.Fragment>
                <DataGroup title="">
            <DataGroupPoint
                label="Address"
                value=""
                contentValue={ <React.Fragment> 
                        { `${ props.stop.address.addressLine1 } ${ props.stop.address.city }, ${ props.stop.address.stateProvince } ${props.stop.address.postalCode}` }
                        {
                            props.changeAddress 
                                ? <button className="stop-change-address" onClick={ props.changeAddress }>[CHANGE]</button>
                                : null
                        }
                    </React.Fragment>
                } 
            />

            <DataGroupPoint
                label="Shipment Time"
                value={
                    props.stop.actionTime
                        ? `${ toLongDateTimeNoSeconds(props.stop.actionTime.local) } ${ TimeZoneAbbreviations[props.stop.actionTime.timeZone] }` 
                        : 'Not Set'
                } 
            />

            <DataGroupPoint
                label="Dealer Name"
                value={props.stop.dealerId} />
                
            <DataGroupPoint
                label="Status"
                value={ DeliveryStatusMetadata[props.stop.status].display } />

            <DataGroupPoint
                label="Note"
                value={props.stop.note} />

            {
                props.entityType === ShipmentType.Truck
                    ? <React.Fragment>
                        <DataGroupPoint
                            label="Mileage"
                            value={ props.stop.distance } />
                        <DataGroupPoint
                            label="Travel Time"
                            value={ props.stop.travelTime.length > 0 ? props.stop.travelTime : 'Not Set' } />
                        <DataGroupPoint
                            label="COD Amount"
                            value={ props.stop.codAmount ? formatCurrency(props.stop.codAmount) : 'Not Set' } />
                    </React.Fragment>
                    : null
            }            
            {
                props.includeFreight
                    ? <DataGroupPoint
                        label="Freight Amount"
                        value={ props.stop.isFixedFreight ? `Fixed - ${formatCurrency(props.stop.fixedFreightAmount!)}` : 'Dynamic' } />
                    : null
            }
            {
                props.stop.address.country === "CA"
                    ? <DataGroupPoint
                        label="PARS Number"
                        value={ props.stop.parsNumber.length > 0 ? props.stop.parsNumber : 'Not Set' } />
                    : null
            }

        </DataGroup>
    </React.Fragment>;
};
